import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  requiredRole: 'employer' | 'job_seeker';
}

export function RoleProtectedRoute({ children, requiredRole }: RoleProtectedRouteProps) {
  const { profile, isLoadingProfile, isProcessingAuth } = useAuth();

  if (isLoadingProfile || isProcessingAuth) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-zinc-950">
        <Loader2 className="h-8 w-8 animate-spin text-white" />
      </div>
    );
  }

  if (!profile || profile.role !== requiredRole) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}